import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import StudioHire from "./pages/StudioHire";
import BespokeSetDesign from "./pages/BespokeSetDesign";
import FashionEvents from "./pages/FashionEvents";
import BoudoirPhotography from "./pages/BoudoirPhotography";
import SceneProduction from "./pages/SceneProduction";
import Gallery from "./pages/Gallery";
import About from "./pages/About";
import Contact from "./pages/Contact";
import BookingTerms from "./pages/BookingTerms";
import Professionals from "./pages/Professionals";
import FreelanceModels from "./pages/FreelanceModels";
import ModelSignUp from "./pages/ModelSignUp";
import ModelProfile from "./pages/ModelProfile";
import ModelEdit from "./pages/ModelEdit";
import ModelAnalytics from "./pages/ModelAnalytics";
import AdminProfessionals from "./pages/AdminProfessionals";
import AdminBookings from "./pages/AdminBookings";
import ProfessionalSignUp from "./pages/ProfessionalSignUp";
import Admin from "./pages/Admin";
import Analytics from "./pages/Analytics";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/studio-hire" element={<StudioHire />} />
          <Route path="/bespoke-set-design-construction" element={<BespokeSetDesign />} />
          <Route path="/fashion-events" element={<FashionEvents />} />
          <Route path="/boudoir-intimate-photography" element={<BoudoirPhotography />} />
          <Route path="/scene-production" element={<SceneProduction />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/about" element={<About />} />
          <Route path="/professionals" element={<Professionals />} />
          <Route path="/professional-signup" element={<ProfessionalSignUp />} />
          <Route path="/join-our-team" element={<ProfessionalSignUp />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/booking-terms" element={<BookingTerms />} />
          <Route path="/freelance-models" element={<FreelanceModels />} />
          <Route path="/model-signup" element={<ModelSignUp />} />
          <Route path="/models/:modelId" element={<ModelProfile />} />
          <Route path="/models/:modelId/edit/:editToken" element={<ModelEdit />} />
          <Route path="/models/:modelId/analytics/:editToken" element={<ModelAnalytics />} />
          <Route path="/ews-admin-panel" element={<Admin />} />
          <Route path="/ews-admin-panel/analytics" element={<Analytics />} />
          <Route path="/ews-admin-panel/professionals" element={<AdminProfessionals />} />
          <Route path="/ews-admin-panel/bookings" element={<AdminBookings />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
